import React from 'react';
// import { Link } from 'react-router-dom';
import { Box, Image, Button, Anchor } from 'grommet';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import DarkLogo from 'assets/logo_dark.png';
import logoImage from 'assets/logo.png';
const LinkBox = styled(Box)`
  &:hover {
    box-shadow: inset 0 -2px 0 0 #fbab31;
  }
`;
const HeaderBox = styled(Box)`
  background: white;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: calc(100% - 0.5rem);
`;
const Header = ({
  ...rest
}) => {
  const history = useHistory();
  return /*#__PURE__*/React.createElement(HeaderBox, {
    fill: "horizontal",
    height: "100px",
    direction: "row",
    align: "center",
    elevation: "small",
    justify: "between",
    pad: {
      horizontal: 'xlarge',
      vertical: 'medium'
    },
    flex: {
      shrink: 0
    }
  }, /*#__PURE__*/React.createElement(Box, {
    onClick: () => {
      history.push('/');
      history.go(0);
    }
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "logo",
    height: "35px",
    src: DarkLogo || logoImage
  })), /*#__PURE__*/React.createElement(Box, {
    justifyContent: "flex-start",
    width: "55%"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    alignSelf: "start",
    gap: "medium"
  }, /*#__PURE__*/React.createElement(LinkBox, {
    margin: {
      horizontal: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Anchor, {
    style: {
      height: '100%',
      padding: '15px',
      textDecoration: 'none'
    },
    color: "black",
    size: "medium",
    label: "Home",
    href: "/#home"
  })), /*#__PURE__*/React.createElement(LinkBox, {
    margin: {
      horizontal: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Anchor, {
    style: {
      height: '100%',
      padding: '15px',
      textDecoration: 'none'
    },
    color: "black",
    size: "medium",
    label: "Features",
    href: "/#features"
  })), /*#__PURE__*/React.createElement(LinkBox, {
    margin: {
      horizontal: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Anchor, {
    style: {
      height: '100%',
      padding: '15px',
      textDecoration: 'none'
    },
    color: "black",
    size: "medium",
    label: "Services",
    href: "/#services"
  })), /*#__PURE__*/React.createElement(LinkBox, {
    margin: {
      horizontal: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Anchor, {
    style: {
      height: '100%',
      padding: '15px',
      textDecoration: 'none'
    },
    color: "black",
    size: "medium",
    label: "About Us",
    href: "/#about-us"
  })))), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    align: "center",
    gap: "medium"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => history.push('/login'),
    alignSelf: "end",
    margin: {
      vertical: 'small'
    },
    label: "Sign In",
    primary: true
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: () => history.push('/register'),
    alignSelf: "end",
    margin: {
      vertical: 'small'
    },
    label: "Sign Up",
    primary: true
  })));
};
export default Header;